export default {"src":"/_next/static/media/clear.2c0e43fd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};